import React from "react";
import { Container, Row, Col, Nav } from "react-bootstrap";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="site-footer">
      <Container>
        <Row className="footer-main">
          {/* Company Info */}
          <Col md={4} className="footer-column">
            <h4 className="footer-brand">Dessert Haven</h4>

            <p className="footer-description">
              Delicious desserts made to brighten your day. Explore our
              collection of sweet treats, perfect for every occasion.
            </p>
          </Col>

          {/* Quick Links */}
          <Col md={4} className="footer-column">
            <h5>Quick Links</h5>

            <Nav className="footer-links flex-column">
              <Nav.Item>
                <Link to="/">Home</Link>
              </Nav.Item>

              <Nav.Item>
                <Link to="/about">About Us</Link>
              </Nav.Item>

              <Nav.Item>
                <Link to="/products">Products</Link>
              </Nav.Item>
            </Nav>
          </Col>

          {/* Social Media */}
          <Col md={4} className="footer-column">
            <h5>Follow Us</h5>

            <Nav className="footer-socials">
              <Nav.Item>
                <a
                  href="https://facebook.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Facebook"
                >
                  <i className="bi bi-facebook"></i>
                </a>
              </Nav.Item>

              <Nav.Item>
                <a
                  href="https://twitter.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Twitter"
                >
                  <i className="bi bi-twitter"></i>
                </a>
              </Nav.Item>

              <Nav.Item>
                <a
                  href="https://instagram.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Instagram"
                >
                  <i className="bi bi-instagram"></i>
                </a>
              </Nav.Item>
            </Nav>
          </Col>
        </Row>

        {/* Copyright */}
        <Row>
          <Col className="footer-bottom">
            <p>
              &copy; {new Date().getFullYear()} Dessert Haven. All Rights
              Reserved.
            </p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
}
